<template>
  <div class="media-item-generator">
    <calendar-input
      v-model="date"
      @input="showRest = true"
      :options="{
        label: 'Date'
      }">
    </calendar-input>
    <template v-if="showRest">
      <text-input
        v-model="publication"
        :options="{
          label: 'Publication'
        }">
      </text-input>
      <text-input
        v-model="title"
        :options="{
          label: 'Title'
        }">
      </text-input>
      <text-input
        v-model="linkUrl"
        :options="{
          label: 'Link URL'
        }">
      </text-input>
      <amazon-media-input
        v-model="image"
        label="Image"
        :options="{
          label: 'Upload Image',
          height: 214,
          width: 350,
          straightToData: true
        }">
      </amazon-media-input>
      <hr/>
      <h4>
        Copy the below code into the Roscon website CMS:
      </h4>
      <div class="card">
        <div class="content">
          <pre>
            {{ code }}
          </pre>
        </div>
      </div>
    </template>
  </div>
</template>

<style>
  .preview {
    background: #fff;
  }
</style>

<script>
  import AmazonMediaInput from '@/components/inputs/AmazonMediaInput'
  import CalendarInput from '@/components/inputs/CalendarInput'
  import TextInput from '@/components/inputs/TextInput'
  export default {
    name: 'GenerateMediaItems',
    components: {
      AmazonMediaInput,
      CalendarInput,
      TextInput
    },
    data () {
      return {
        image: {
          key: '',
          fileName: '',
          fileType: ''
        },
        showRest: false,
        date: '',
        linkUrl: '',
        publication: '',
        title: ''
      }
    },
    computed: {
      imageUrl () {
        return 'https://roscon.s3.amazonaws.com/' + this.image.key
      },
      day () {
        return moment(this.date).date()
      },
      month () {
        return moment(this.date).format('MMM')
      },
      year () {
        return moment(this.date).year()
      },
      formattedDate () {
        return moment(this.date).format('DD/MM/YYYY')
      },
      code () {
        return `
        <!-- ${this.publication} - ${this.formattedDate} -->
        <div style="float: left; padding: 0 1.7rem; width: 320px;">
          <div style="background-color: #fff; min-height: 336px; position: relative; background: url('${this.imageUrl}') top center / contain no-repeat;">
            <a target="_blank" href="${this.linkUrl}" rel="noopener noreferrer">
              <span style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></span>
            </a>
            <div style="position: absolute; top: 0; left: 0; background-color: #004b8e; color: #fff; padding: 0.8em;">
              <a target="_blank" href="${this.linkUrl}" style="color: #fff; text-decoration: none;" rel="noopener noreferrer">
                <span style="display: block; text-align: center; font-weight: bold; font-size: 24px; text-shadow: 2px 3px 2px rgba(0, 0, 0, 0.18);">
                  ${this.day}
                </span>
                <span style="display: block; text-align: center; text-transform: uppercase; font-size: 12px;">
                  ${this.month}
                </span>
                <span style="display: block; text-align: center; font-size: 12px;">
                  ${this.year}
                </span>
              </a>
            </div>
            <div style="position: absolute; bottom: 0; width: 100%; height: 141px;">
              <div style="background-color: #fff; padding: 1em; position: relative; z-index: 1;">
                <a target="_blank" href="${this.linkUrl}" style="font-size: 12px; text-decoration: none;" rel="noopener noreferrer">
                  ${this.publication}
                </a>
                <h3 style="margin-top: 10px;">
                  <a target="_blank" href="${this.linkUrl}" style="text-decoration: none;" rel="noopener noreferrer">
                    ${this.title}
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>`
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/MediaItem.vue